<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item>網站導覽</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          網站導覽 <i class="fas fa-sitemap"></i> <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section>
          <p class="c-gray-666">
            本網站依照「無障礙網頁開發規範」原則設計， 遵循無障礙網站設計之規範提供網頁導盲磚(:::)、網站導覽 (Site Navigator)、鍵盤快速鍵 (Access Key) 等設計方式。
            下列為本網站使用鍵盤快速鍵 (Access Key) 操作方式說明：
          </p>
          <p class="c-gray-666">
            本網站的便捷鍵﹝Accesskey，也稱為快速鍵﹞設定如下：<br/>
            <ul>
              <li>Alt+U (IE), Alt+Shift+U (Firefox)：上方主選單連結區。</li>
              <li>Alt+C (IE), Alt+Shift+C (Firefox)：主要內容顯示區，此區塊呈現各網頁的網頁內容。</li>
              <li>Alt+B (IE), Alt+Shift+B (Firefox)：下方選單連結區。</li>
              <li>Alt+S (IE), Alt+Shift+S (Firefox)：內容搜尋。</li>
            </ul>
          </p>
        </section>
        <section>
          <div class="table">
            <div class="tr">
              <div class="td">
                <ul>
                  <li>
                    <a href="/">網站資訊</a>
                    <ul>
                      <li><a href="/about">關於本站</a></li>
                      <li><a href="/sitemap">網站導覽</a></li>
                      <li><a href="/faq">常見問題</a></li>
                      <li><a href="/contact">聯絡我們</a></li>
                    </ul>
                  </li>
                  <li><a href="/">主題專區</a></li>
                  <li><a href="/news">最新消息</a></li>
                  <li><a href="/recommended">本日精選</a></li>
                  <li><a href="/collection">館藏資源</a></li>
                </ul>
              </div>
            </div>
          </div>
          
        </section>
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  export default {
    name: 'sitemap',
    components: {
      HeaderSlide,
    },
  }
</script>

<style lang="scss" scoped>
  ul {
    padding-left: 20px;
    margin: 10px;
    list-style: disc;
    li {
      margin-bottom: 10px;
      &:last-child {
        margin: 0;
      }
    }
  }
  .table {
    display: table;
    width: 100%;
    @media screen and (max-width: 640px){
      display: block;
    }
    .tr {
      display: table-row;
      @media screen and (max-width: 640px){
        display: block;
      }
    }
    .td {
      display: table-cell;
      @media screen and (max-width: 640px){
        display: block;
      }
    }
  }
  .accesskey-content{
    color: white;
  }
</style>
